module.exports = "/_next/static/images/binary-12ad54551da1cc2537ea0cdbe1e5055c.svg";